import { useContext, useState } from 'react';
import { func } from 'prop-types';
import { Modal } from 'antd';

import { i18nContext } from 'context/i18n';
import { BoxSVG } from 'components/iconsSVG/box';
import { CloseMdSVG } from 'components/iconsSVG/close';

import { dataLayerHandleEvent } from 'utils/dataLayers';

import styles from './style.module.css';

export function PreSaleModal({ onClose }) {
  const { t } = useContext(i18nContext);
  const [ visible, setVisible ] = useState(false);

  const handleChangeVisible = (fixedValue = null) => {
    const visibleValue = fixedValue === null ? !visible : fixedValue;

    if (visibleValue) {
      dataLayerHandleEvent({
        event: 'item_info',
        event_category: 'product detail',
        event_detail_1: 'pre order',
        event_detail_2: '',
      });
    }
    setVisible(visibleValue);
  };

  return (<>
    <a className={styles.presalePopupText} onClick={handleChangeVisible}>{t('ficha.producto', 'what.is.a.presale', '***¿Qué es una Pre-Order?')}</a>
    <Modal
      title=""
      width={'760px'}
      visible={visible}
      onCancel={onClose}
      footer={null}
      closable={false}
    >
      <span onClick={() => handleChangeVisible(false)} className={styles.closeSvg}>
        <CloseMdSVG />
      </span>
      <BoxSVG />
      <h3 className={styles.presaleTitle}>{t('ficha.producto', 'what.is.a.presale', '***¿Qué es una Pre-Order?')}</h3>
      <p dangerouslySetInnerHTML={{
        __html: t(
          'ficha.producto',
          'presale.popup.content',
          '***A pre-order is the purchase of a Camper product that is not yet in stock.<br /> Pre-orders are given priority and sent out immediately after being received at our warehouse. An estimated shipping date can be found in the product information.',
        ),
      }}>
      </p>
    </Modal>
  </>
  );
}

PreSaleModal.defaultProps = {
  onClose: () => false,
};

PreSaleModal.propTypes = {
  onClose: func,
};

export default PreSaleModal;
